module.exports = __webpack_public_path__ + "static/media/icon-filter.c25a009a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-filter.svg
// module id = ./src/assets/images/icon-filter.svg
// module chunks = 6